import React, { ChangeEvent } from 'react';
import { Typography } from '../Typography/Typography';
import styles from './ImageUpload.module.scss';
import { Upload } from '../../assets/icons/Upload';
import { Bin } from '../../assets/icons/Bin';

export interface IImageUploadProps {
  title?: string;
  prompt: string;
  image: File | string | null;
  setImage: React.Dispatch<React.SetStateAction<File | string | null>>;
  shouldDeleteImage?: boolean;
  altText?: string;
}
const logoUploadId = 'brand-logo-input';

const ImageUpload = ({
  image,
  setImage,
  title,
  prompt,
  shouldDeleteImage = true,
  altText = 'uploaded logo',
}: IImageUploadProps) => {
  const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setImage(files[0]);
      e.target.value = ''; // clear value to allow re-submitting the same file
    }
  };

  return (
    <>
      {title && (
        <Typography size="M" weight="semi-bold" className={styles['logo-text']}>
          {title}
        </Typography>
      )}
      {image ? (
        <>
          <img
            src={typeof image === 'string' ? image : window.URL.createObjectURL(image)}
            className={styles.logo}
            alt={altText}
          />
          <div className={styles['image-controls']}>
            <label htmlFor={logoUploadId} className={styles['image-control']}>
              <Upload />
              <Typography className={styles.primary}>Replace</Typography>
            </label>
            {shouldDeleteImage && (
              <button type="button" className={styles['image-control']} onClick={() => setImage(null)}>
                <Bin />
                <Typography className={styles.primary}>Delete</Typography>
              </button>
            )}
          </div>
        </>
      ) : (
        <label htmlFor={logoUploadId}>
          <div className={styles['visible-input']}>
            <Upload />
            <Typography weight="regular" className={styles.primary}>
              {prompt}
            </Typography>
          </div>
        </label>
      )}
      <input
        className={styles['hidden-input']}
        type="file"
        id={logoUploadId}
        accept="image/png, image/jpeg"
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleImageUpload(e)}
      />
    </>
  );
};

export default ImageUpload;
